<template>
  <div class="form-group  row">
    <label >{{ name }}</label>
    <select class="form-control m-input text-left" :value="value" @input="update( $event)">
      <option :value="optionDefault.value"  v-if="optionDefault">{{ optionDefault.name }}</option>
      <option :value="itemData.value" :selected="itemData.value===value" v-for="(itemData,indexData) in optionData" :key="'data' + indexData">
        {{ itemData.name }}
      </option>
      <option :value="item" v-for="(item,index) in option"  :key="index">{{ item }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "ControlLibrarySelect",
  props: [
    "name", "value", "field", "option", "optionData", "optionDefault"
  ],
  methods: {
    update(e) {
       let name = e.target.selectedOptions[0].label;
       let value = e.target.value

      this.$emit('update', {field: this.field, value: value, name: name})
      if (this.field==="sign_id")
        this.$emit('update', {field: "filler", value: name})
    }
  }
}
</script>

<style scoped>

</style>
